import * as React from "react";

import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { parse_text_with_link } from "./details-utils"

export const DescTool = (props: any) => {

    const { t, i18n } = useTranslation();

    return (
        <>
            {/* Disclaimer for RoboDK objects */}
            {
                props.data.hasOwnProperty("B") && props.data["B"] == "RoboDK" && (
                    <p>
                        {
                            (t('details-desc.robodk'))
                                .replace(/\{name\}/g, props.data["N"])
                        }
                    </p>
                )
            }

            <p>
                {/* Description */}
                {
                    props.data.hasOwnProperty("N") && (
                        (t('details-desc.tool.name'))
                            .replace(/\{name\}/g, props.data["N"])
                    )
                }
                {
                    props.data.hasOwnProperty("N") && props.data.hasOwnProperty("W") && (
                        <p>
                            {
                                (t('details-desc.tool.weight'))
                                    .replace(/\{name\}/g, props.data["N"])
                                    .replace(/\{weight\}/g, props.data["W"])
                                + " " +
                                (t('details-desc.tool.robots'))
                                    .replace(/\{name\}/g, props.data["N"])
                                    .replace(/\{weight\}/g, props.data["W"])
                            }
                        </p>
                    )
                }
            </p>

            {/* Applications */}
            {
                <p>
                    {
                        props.data.hasOwnProperty("N") && props.data.hasOwnProperty("AP") && (
                            (t('details-desc.apps'))
                                .replace(/\{name\}/g, props.data["N"])
                                .replace(/\{applications\}/g, t('application.' + props.data["AP"]))
                        )
                    }
                </p>
            }

            {/* Brand */}
            {
                props.data.hasOwnProperty("N") && props.data.hasOwnProperty("B") && (
                    <p>
                        {
                            (t('details-desc.brand'))
                                .replace(/\{name\}/g, props.data["N"])
                                .replace(/\[\{brand\}\]\(\{link\}\)/g, props.data["B"])
                        }
                    </p>
                )
            }

            {/* Browse the library */}
            {
                parse_text_with_link(
                    (t('details-desc.browse'))
                        .replace(/\{link\}/g, (window.Settings.LOCAL_BUILD)
                            ? "http://localhost:3001?Lang=" + window.Languages.language + "&n=" + props.data["F"].split(".", 1)[0]
                            : "/" + (window.Languages.language == "en" ? "" : (window.Languages.language + "/")) + "tools?n=" + props.data["F"].split(".", 1)[0])
                )
            }
        </>
    )
};
